import { Loader2 } from "lucide-react";
import type { AiReviewJob } from "@/schemas/ai-review";

function progressText(job: AiReviewJob): string {
  if (job.scope === "photo") return "Checking this photo…";
  if (job.status === "queued" || job.total === 0) return "Starting the AI check…";
  const done = job.reviewed + job.failed;
  return `Checking ${done.toLocaleString("en-US")} of ${job.total.toLocaleString("en-US")} photos…`;
}

/** A queued or running AI check, in place of the button that started it. */
export function AiJobProgress({ job }: { job: AiReviewJob }) {
  const done = job.reviewed + job.failed;
  const percent = job.total > 0 ? Math.min(100, Math.round((done / job.total) * 100)) : 0;
  return (
    <div
      role="status"
      data-testid="ai-job-progress"
      data-status={job.status}
      className="flex min-w-0 items-center gap-2"
    >
      <Loader2 className="size-4 shrink-0 animate-spin text-muted-foreground" aria-hidden />
      <span className="text-sm text-muted-foreground tabular-nums">{progressText(job)}</span>
      {job.scope === "album" && job.total > 0 && (
        <div className="h-1.5 w-20 shrink-0 overflow-hidden rounded-full bg-muted" aria-hidden>
          <div className="h-full bg-primary" style={{ width: `${percent}%` }} />
        </div>
      )}
    </div>
  );
}
